import Scrollable from './Scrollable';
export default Scrollable;
//# sourceMappingURL=index.js.map